import React from 'react';

import { Typography } from '@occc/ui-design-system';
import { ConstraintTimeOfDayFragment } from '@occc/graphql';

import {
  DateTimeFormat,
  DateTimeFormatParse,
  formatDateTime,
  parseDate,
} from '../../../../lib/date';

interface ITimeOfDayProps {
  timeOfDayConstraints: ConstraintTimeOfDayFragment[];
}

const formatTime = (time: string): string =>
  formatDateTime(parseDate(time, DateTimeFormatParse.Time24hFull), DateTimeFormat.Time12h);

export const TimeOfDay: React.FC<ITimeOfDayProps> = ({ timeOfDayConstraints }) => {
  return (
    <>
      <Typography variant='body2' gutterBottom>
        Time of day
      </Typography>
      {timeOfDayConstraints.map((item, index) => (
        <Typography key={index} gutterBottom>
          {`${formatTime(item.availableDailyStartingAtTime)} - ${formatTime(
            item.availableDailyEndingAtTime,
          )}`}
          <Typography variant='body2' display='inline' component='span'>
            {` (${item.timezone})`}
          </Typography>
        </Typography>
      ))}
    </>
  );
};
